import React from 'react';
import { motion } from 'framer-motion';

export default function GuideSection() {
  return (
    <motion.section 
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.2, duration: 0.8 }}
      className="relative z-10 px-0 md:px-4"
    >
      <div className="max-w-6xl mx-auto">
        {/* Glow Effects */}
        <div className="hidden md:block absolute -top-40 -left-40 w-96 h-96 bg-glow-purple/10 rounded-full blur-[120px] pointer-events-none"></div>
        <div className="hidden md:block absolute -bottom-40 -right-40 w-96 h-96 bg-glow-cyan/10 rounded-full blur-[120px] pointer-events-none"></div>

        <div className="bg-navy-nav/30 backdrop-blur-3xl rounded-[1.5rem] md:rounded-[2.5rem] p-4 md:p-10 border border-white/5 shadow-2xl relative overflow-hidden group">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-badge opacity-50"></div>
          
          <div className="mb-8 md:mb-10 flex flex-col md:flex-row md:items-center justify-between gap-6 px-2">
            <div>
              <h3 className="text-xl md:text-2xl font-bold text-white/90 mb-2">Interactive BASICS Guide</h3>
              <p className="text-sm md:text-base text-text-body">Master the fundamental signals and system setup in real-time.</p>
            </div>
            <div className="flex">
              <span className="px-4 py-1.5 bg-green-500/5 border border-green-500/10 text-green-400/80 text-[10px] font-bold uppercase tracking-widest rounded-full">Live Status: Active</span>
            </div>
          </div>

          <div 
            style={{ 
              position: 'relative', 
              height: 0, 
              width: '100%', 
              overflow: 'hidden', 
              zIndex: 9, 
              borderRadius: '16px', 
              boxSizing: 'border-box', 
              paddingBottom: 'calc(100% + 32px)', 
              background: '#0A1628', /* Dark edges color for iframe container */
              border: '1px solid rgba(255,255,255,0.03)' 
            }}
            className="shadow-3xl sm:!pb-[calc(46.32812500%+32px)]"
          >
            <iframe 
              src="https://www.guidejar.com/embed/57a0f9ee-da6b-4f53-b786-094d68fd9497?type=1&controls=on" 
              width="100%" 
              height="100%" 
              style={{ position: 'absolute', inset: 0 }} 
              allowFullScreen 
              frameBorder="0" 
              title="ProfitLense BASICS Guide" 
              sandbox="allow-scripts allow-popups allow-forms"
            ></iframe>
          </div>

          <div className="mt-8 md:mt-10 flex flex-wrap items-center justify-center gap-x-8 md:gap-x-12 gap-y-4 px-2">
            <div className="flex items-center gap-2 md:gap-3 opacity-60 hover:opacity-100 transition-opacity">
              <div className="w-2 h-2 rounded-full bg-brand-pink"></div>
              <span className="text-[9px] md:text-xs text-text-body font-bold uppercase tracking-widest">Indicator Setup</span>
            </div>
            <div className="flex items-center gap-2 md:gap-3 opacity-60 hover:opacity-100 transition-opacity">
              <div className="w-2 h-2 rounded-full bg-brand-secondary"></div>
              <span className="text-[9px] md:text-xs text-text-body font-bold uppercase tracking-widest">TradingView Integration</span>
            </div>
            <div className="flex items-center gap-2 md:gap-3 opacity-60 hover:opacity-100 transition-opacity">
              <div className="w-2 h-2 rounded-full bg-brand-primary"></div>
              <span className="text-[9px] md:text-xs text-text-body font-bold uppercase tracking-widest">Signal Strategies</span>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
}